const Mutations = Object.freeze({
	SET_PROJECT_USERS:
		'reportBuilderModule/reportBuilder/reportDetails/assignUsers/SET_PROJECT_USERS',
	SET_REPORT_USERS:
		'reportBuilderModule/reportBuilder/reportDetails/assignUsers/SET_SET_REPORT_USERS',
	SET_LOADING:
		'reportBuilderModule/reportBuilder/reportDetails/assignUsers/SET_LOADING',
});
export const Actions = Object.freeze({
	LOAD_PROJECT_USERS:
		'reportBuilderModule/reportBuilder/reportDetails/assignUsers/LOAD_PROJECT_USERS',
	LOAD_REPORT_USERS:
		'reportBuilderModule/reportBuilder/reportDetails/assignUsers/LOAD_REPORT_USERS',
	LOAD: 'reportBuilderModule/reportBuilder/reportDetails/assignUsers/LOAD',
	INSERT: 'reportBuilderModule/reportBuilder/reportDetails/assignUsers/INSERT',
	DELETE: 'reportBuilderModule/reportBuilder/reportDetails/assignUsers/DELETE',
});
export const Getters = Object.freeze({
	ASSIGNED_USERS:
		'reportBuilderModule/reportBuilder/reportDetails/assignUsers/ASSIGNED_USERS',
	UNASSIGNED_USERS:
		'reportBuilderModule/reportBuilder/reportDetails/assignUsers/UNASSIGNED_USERS',
	IS_LOADING:
		'reportBuilderModule/reportBuilder/reportDetails/assignUsers/IS_LOADING',
});
import dataService from '../../../../../services/data/reportBuilderService';
import { GeneralActions } from '../../../../actions';

export default {
	state: {
		projectUsers: [],
		reportUsers: [],
		loading: false,
	},

	mutations: {
		[Mutations.SET_PROJECT_USERS](state, items) {
			state.projectUsers = items;
		},
		[Mutations.SET_REPORT_USERS](state, items) {
			state.reportUsers = items;
		},
		[Mutations.SET_LOADING](state, item) {
			state.loading = item;
		},
	},
	actions: {
		[Actions.LOAD_PROJECT_USERS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getProjectUsers(id)
					.then((resp) => {
						commit(Mutations.SET_PROJECT_USERS, resp.data);
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD_REPORT_USERS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getReportUsers(id)
					.then((resp) => {
						commit(Mutations.SET_REPORT_USERS, resp.data);
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.LOAD](
			{ dispatch },
			{ projectId: projectId, reportId: reportId }
		) {
			return Promise.all([
				dispatch(Actions.LOAD_PROJECT_USERS, projectId),
				dispatch(Actions.LOAD_REPORT_USERS, reportId),
			]);
		},
		[Actions.INSERT]({ commit, dispatch }, { reportId, users }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertReportUser(reportId, users)
					.then(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.DELETE]({ commit, dispatch }, { reportId, users }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				dataService
					.deleteReportUser(reportId, users)
					.then(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
	},
	getters: {
		[Getters.ASSIGNED_USERS]: (state) => {
			let result = [];
			state.reportUsers.forEach((p) => {
				let assigned = state.projectUsers.find(
					(x) => x.UserId == p.UserId
				);
				if (assigned) result.push(p);
			});
			return result.sort((a, b) =>
				a.FirstName.concat(' ', a.LastName).localeCompare(
					b.FirstName.concat(' ', b.LastName)
				)
			);
		},
		[Getters.UNASSIGNED_USERS]: (state) => {
			let result = [];
			state.projectUsers.forEach((p) => {
				let assigned = state.reportUsers.find(
					(x) => x.UserId == p.UserId
				);
				if (!assigned) result.push(p);
			});

			return result.sort((a, b) =>
				a.UserFirstName.concat(' ', a.UserLastName).localeCompare(
					b.UserFirstName.concat(' ', b.UserLastName)
				)
			);
		},
	},
};
